import { FC, ReactNode } from 'react';

/**
 * The card chrome DetailsPanel already uses, made available for sections whose body is not a
 * label/value list — tables, timelines, checklists. Previously each of those hand-rolled the
 * same `shadow-sm ring-1 ring-gray-200` shell, so the same screen could show three subtly
 * different cards.
 */
const SectionCard: FC<{
  title?: string;
  subTitle?: ReactNode;
  headerContent?: ReactNode;
  children: ReactNode;
  bodyClassName?: string;
}> = ({ title, subTitle, headerContent, children, bodyClassName = 'px-4 py-3 sm:p-4' }) => (
  <div className="shadow-sm ring-1 ring-gray-200 rounded-md sm:rounded-lg md:col-span-2">
    {title || headerContent ? (
      <div className="border-b border-gray-200 px-4 py-4 sm:px-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          {title ? (
            <h2 className="text-lg font-semibold leading-7 text-gray-900">{title}</h2>
          ) : null}
          {subTitle ? <div className="text-sm text-gray-600">{subTitle}</div> : null}
        </div>
        {headerContent ? <div className="flex items-center gap-2">{headerContent}</div> : null}
      </div>
    ) : null}
    <div className={bodyClassName}>{children}</div>
  </div>
);

export default SectionCard;
